<template>
    <div>
        <div class="footer_container">
            <div class="footer_main">
                <div class="footer_content">
                    <div class="logo_content">
                        <div><img :src="logoImage"/></div>
                        <div class="btn" @click="openCooperation">{{lang.coop}}</div>
                    </div>
                    <div class="address">
                        <h2 class="title">{{lang.companyAddress}}</h2>
                        <p v-for="(item, index) in companyAddress" :key='index'>{{isCn?item.cnStr:item.enStr}}</p>
                    </div>
                    <div class="service_number">
                        <div class="code">
                            <div class="QR_code" v-for="(item, index) in weChatService" :key='index'>
                                <p>{{isCn?item.cnStr:item.enStr}}</p>
                                <img :src="item.other" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="tel">
                        <h2 class="title" v-if="serviceHotLine.length>0">{{isCn?serviceHotLine[0].cnStr:serviceHotLine[0].enStr}}</h2>
                        <p v-if="serviceHotLine.length>0">{{serviceHotLine[0].other.split(' ')[0]}} ( {{lang.china}} )</p>
                        <p v-if="serviceHotLine.length>0">{{serviceHotLine[0].other.split(' ')[1]}} ( {{lang.oversea}} )</p>
                    </div>
                </div>
                <div class="record" v-if="recordAddress.length>0"><a :href="recordAddress[0].other">{{isCn?recordAddress[0].cnStr:recordAddress[0].enStr}}</a></div>
            </div>
        </div>
        <Cooperation ref="cooperation"></Cooperation>
    </div>
</template>
<script>
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/language';
import Cooperation from '@/views/Cooperation.vue';

export default {
    name: 'Footer',
    props: {
    },
    components: {
        Cooperation,
    },
    data() {
        return {
            lang: getLang(),
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            companyAddress: [],
            weChatService: [],
            serviceHotLine: [],
            recordAddress: [],
            logoImage: '',
        };
    },
    mounted() {
        ajax.get('/web/common/bottom_list.json', { }).then((result) => {
            this.companyAddress = result.data.companyAddress || [];
            this.weChatService = result.data.weChatService || [];
            this.serviceHotLine = result.data.serviceHotLine || [];
            this.recordAddress = result.data.recordAddress || [];
        }).catch(() => {});
        ajax.get('/web/common/logo.json', { }).then((result) => {
            this.logoImage = result.data;
        }).catch(() => {});
    },
    methods: {
        openCooperation() {
            this.$refs.cooperation.openModel();
        },
    },
};
</script>

<style lang="less" scoped>
.footer_container {
    width: auto;
    min-width: 1200px;
    min-height: 277px;
    background: #C71F4B;
    display: flex;
    justify-content: center;
    padding-top: 60px;
}
.footer_main{
    width: 1200px;
    height: auto;
    display: flex;
    flex-direction: column;
    .footer_content{
        display: flex;
    }
    .logo_content{
        width: 110px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        img{
            width: 58px;
            height: 69px;
        }
        .btn{
            width:110px;
            padding: 8px;
            line-height: 18px;
            word-break: break-word;
            text-align: center;
            color: #fff;
            background:rgba(255,255,255,0.25);
            margin-top: 30px;
            cursor: pointer;
        }
    }
    .address{
        width: 320px;
        margin-left: 112px;
    }
    .service_number{
        width: 280px;
        margin-top: 15px;
        .code{
            width: 260px;
            display: flex;
            flex-wrap: wrap;
        }
    }
    .links .title,.address .title,.service_number .title{
        margin-bottom: 16px;
        font-size:15px;
        font-weight:500;
        color:rgba(255,255,255,0.85);
    }
    .links p,.address p{
        font-size:12px;
        font-weight:400;
        color:rgba(255,255,255,0.85);
        line-height:18px;
        text-align: left;
        padding-bottom: 6px;
        margin-right: 30px;
    }
    .QR_code{
        min-width: 126px;
        max-width: 126px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        img{
            display: block;
            width: 90px;
            height: 90px;
        }
        p{
            width: 100%;
            font-size:14px;
            font-weight:600;
            color:rgba(255,255,255,0.85);
            line-height:16px;
            margin-bottom: 10px;
            word-wrap:break-word;
            word-spacing:normal;
            text-align: center;
        }
        &:nth-child(2n){
            margin-right: 0;
        }
    }
    .tel{
        width: 373px;
        margin-top: 15px;
        .title{
            text-align: right;
            font-size:20px;
            font-weight:600;
            color:rgba(255,255,255,0.85);
            line-height:28px;
        }
        p{
            width: 373px;
            font-size:24px;
            font-weight:normal;
            color:rgba(255,255,255,0.85);
            margin-top: 10px;
            word-wrap:break-word;
            word-break:break-all;
            font-weight: 600;
            text-align: right;
        }
    }
    .record{
        font-size:12px;
        line-height:14px;
        margin: 44px 0 15px 0;
        text-align: center;
        a{
            color:rgba(255,255,255,0.65);
        }
    }
}
</style>
